export const PostHogConst = {
    token: 'phc_AI6V76Fo81ExKWfOvpOZ4HalAr5kiUPnxqEEbFJiS7G',
    //token: 'phc_LWsw4xk1B0WtrozOVrjF6pdYIqkdBgrnD5DfSejMfad', //local
    cookie_prefix: 'ph_',
    cookie_ending: '_posthog',
};
